import {
    useMemo,
} from 'react'

import StatusHandler from 'app/shared-components/StatusHandler'
import Button from 'app/shared-components/Button'
import useAddCopiedItemWorkaround from 'app/shared-components/SkyNetTable/hooks/useAddCopiedItemWorkaround'

import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import AlLeasePricingRequests from 'app/requests/PharmaLeasePricing.requests'
import AlLeasePricingForm from '../AlLeasePricingForm'
import useGetAlLeasePricing from '../hooks/useGetAlLeasePricing'

const defaultProps = {
    id: undefined,
}

const AlLeasingPricingUpdate = ({
    id,
}: { id?: number }) => {
    const {
        AlLeasePricing: AlLeasePricingRoutes,
    } = usePricingRoutes()
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useGetAlLeasePricing(id)

    useAddCopiedItemWorkaround({
        data,
    })

    const customButtons = useMemo(() => {
        return (
            [<Button
                label="Copy"
                key="copy-button"
                onClick={() => {
                    AlLeasePricingRoutes.Copy.navigate({
                        params: {
                            key: id,
                            copy: 'copy',
                        },
                    })
                }}
            />]
        )
    }, [
        AlLeasePricingRoutes,
        id,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <AlLeasePricingForm
                data={data}
                onSuccess={invalidate}
                onCancel={invalidate}
                requestParam={AlLeasePricingRequests.update({
                    id,
                })}
                customButtons={customButtons}
            />

        </StatusHandler>
    )
}

AlLeasingPricingUpdate.defaultProps = defaultProps

export default AlLeasingPricingUpdate
